import Icon from '../../components/Icon'
import styled from '../../config/theme'

const Container = styled.div`
  display: flex;
  margin-bottom: 50px;

  > * {
    flex: 1;
  }

  @media screen and (max-width: ${props => props.theme.mediaQueries.home}) {
    flex-direction: column;
  }
`

const Video = styled.video`
  width: calc(50% - 20px);
  margin-left: 20px;
  height: 100%;
  border-radius: 5px;

  @media screen and (max-width: ${props => props.theme.mediaQueries.home}) {
    width: 100%;
    margin-top: 20px;
    margin-left: 0;
  }
`

const Tile = styled.div`
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const TileIcon = styled(Icon)`
  background: ${props => props.theme.color.lightBluishGray};
  border-radius: 200px;
  height: 144px;
  width: 144px;
  object-fit: scale-down;
  object-position: center;

  + * {
    margin-bottom: 0;
  }
`

const Company = styled.div`
  display: flex;
  justify-content: center;
  align-items: center; 

  border: 1px solid ${props => props.theme.color.lightGray};
  border-radius: 50%;
  padding: 5px;

  &:before {
    content: '';
    display: block;
    padding-bottom: 100%;
  }

  a > img {
    object-fit: contain;
    width: 100%;
    height: 100%;
    object-position: center;
    border-radius: 85px;
  }
`

const Testimonial = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  height: 271px;

  > img {
    max-width: 208px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    clip-path: polygon(0 0, 0 100%, 80% 100%, 100% 0);
    object-fit: cover;
  }
  @media screen and (max-width: 812px) {
    > img {
      display: none;
    }   
  }
`

const TestimonialContent = styled.div`
  display: flex;
  flex-direction: column;

  width: 70%;
  padding-left: 45px;
  height: 100%;

  p {
    white-space: pre-wrap;
    color: ${props => props.theme.color.darkBlue};
  }

  @media screen and (max-width: 812px) {
    width: 100%;
    padding: 10px;
    > h1 {
      margin-top: 0px !important;
      justify-content: left !important;
      white-space: pre-wrap;
    }
    > h2 {
      justify-content: left !important;
      white-space: pre-wrap;
    }
    p {
      margin-top: 0px;
      margin-left: 0px;
    }
  }
`

const Banner = styled.div`
  height: 80vh;
  width: 100vw;
  background: #1D67A2;
  margin-top: -50px;
  margin-left: calc((100vw - ${props => props.theme.mediaQueries.layout}) / 2 * -1);
  margin-bottom: 60px;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: ${props => props.theme.mediaQueries.layout}) {
    margin-left: calc((100vw - ${props => props.theme.mediaQueries.layoutMobile}) / 2 * -1);
  }

  @media screen and (max-width: 1024px) {
    height: 60vh;
  }

  > h2 {
    margin: 10px 0;
    font-family: Roboto;
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    text-align: center;
  }
  > button { 
    margin-top: 56px;
  }

  > video {
    z-Index: 0;
    position: relative;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;

  + * {
    margin-bottom: 30px;
  }
`

export { Container, Video, Tile, TileIcon, Company, Testimonial, TestimonialContent, Banner, }

